import useFeatureFlags from 'hooks/useFeatureFlags'
import {
  isStructuredLogsEnabled,
  STRUCTURED_LOGS_FLAG
} from './structuredLogsFlag'

const useStructuredLogsFlag = () => {
  const flags = useFeatureFlags({ flagNames: [STRUCTURED_LOGS_FLAG] as const })
  return {
    isLoading: Boolean(flags?.isLoading),
    enabled: isStructuredLogsEnabled(flags?.data?.[STRUCTURED_LOGS_FLAG])
  }
}

export default useStructuredLogsFlag
